// extracted by mini-css-extract-plugin
module.exports = {"guideGrid":"Index_guideGrid__0E34e","imgClass":"Index_imgClass__t7gax"};